module.exports = "//public.zight.com/packs/media/images/markers/m_6-b63f3ec00b3d9d7683a8bc8b5f981907.svg";